import module from 'fan/proyecto/module.js'
import template from './template.html'
import placeholders from '../../placeholders.json'

export class FanProyectoDocumentosPlantillaContenidoComponent {
  modificado = false
  procesando = false
  placeholders = placeholders
  idProyecto = undefined
  idPlantilla = undefined
  version = undefined
  constructor ($location, $state, FanProyectoDocumentosPlantillaContenidoService, FanProyectoDocumentosPlantillaPdfService) {
    this.$location = $location
    this.$state = $state
    this.FanProyectoDocumentosPlantillaContenidoService = FanProyectoDocumentosPlantillaContenidoService
    this.FanProyectoDocumentosPlantillaPdfService = FanProyectoDocumentosPlantillaPdfService

  }

  $onInit () {
    this.promise = this.FanProyectoDocumentosPlantillaContenidoService.get(this.idProyecto, this.idPlantilla, this.version)
      .then((response) => (this.data = response.data))
  }

  actualizar (data) {
    this.modificado = true
    if (data.contenido) {
      this.data.contenido = data.contenido
    }
  }

  cerrar () {
    this.$state.go('^')
  }

  vistaPrevia () {
    this.src = this.FanProyectoDocumentosPlantillaPdfService.link(this.idProyecto, this.idPlantilla, this.version)
  }

  guardar (data) {
    this.guardando = false

    if (data) {
      this.modificado = false

      Object.assign(this.data, data)
    }

    if (this.version !== this.data.version) {
      this.version = this.data.version
      this.$location.search({version: this.version})
    }
  }
}

module.component('fanProyectoDocumentosPlantillaContenido', {
  controller: FanProyectoDocumentosPlantillaContenidoComponent,
  template: template,
  bindings: {
    idProyecto: '<',
    idPlantilla: '<',
    version: '<',
  },
})



// WEBPACK FOOTER //
// ./src/fan/proyecto/components/documentos/plantilla/contenido/component.js